export default __webpack_public_path__ + "static/media/anchor.3ed194e6.svg";